module.exports = __webpack_public_path__ + "static/media/ic_general_borders_gray.10062e28.svg";